module.exports = __webpack_public_path__ + "img/logo.d43d838.png";